(function () {
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const BRANCH_KEY = "riftbound-trainer-branch";
  const BLUNDER = 0.15;
  const MISTAKE = 0.05;
  const POLL_MS = 1500;
  const CURVE_W = 1000;
  const CURVE_H = 240;
  const CURVE_PAD = 12;

  const S = {
    list: null,
    games: null,
    rating: null,
    open: null,
    openId: null,
    loading: null,
    err: null,
    note: null,
    queued: {},
    poll: null,
    host: null,
  };

  function get(url, cb) {
    RB.Api.get(url, true).then(cb).catch(function (e) {
      S.err = "Could not load " + url + ": " + e.message;
      paint();
    });
  }

  function post(url, body, cb) {
    RB.Api.post(url, body)
      .then(function (r) { return r.body; })
      .then(function (j) {
        if (j && j.error) { S.err = j.error; paint(); return; }
        cb(j);
      })
      .catch(function (e) { S.err = e.message; paint(); });
  }

  function refresh() {
    get("/api/trainer/reviews", function (j) { S.list = Array.isArray(j) ? j : []; paint(); });
    get("/api/trainer/games", function (j) { S.games = Array.isArray(j) ? j : []; paint(); });
    get("/api/trainer/rating", function (j) { S.rating = j && j.glicko ? j : null; paint(); });
  }

  function pending() {
    if (!S.list) return [];
    return S.list.filter(function (r) { return r.status === "queued" || r.status === "running"; });
  }

  function schedulePoll() {
    if (S.poll) return;
    if (!pending().length) return;
    if (S.host && S.host.isConnected === false) return;
    S.poll = setTimeout(function () {
      S.poll = null;
      get("/api/trainer/reviews", function (j) { S.list = Array.isArray(j) ? j : []; paint(); });
    }, POLL_MS);
  }

  function openReview(id) {
    S.openId = id;
    S.open = null;
    S.loading = id;
    S.err = null;
    paint();
    get("/api/trainer/review/" + encodeURIComponent(id), function (j) {
      S.loading = null;
      if (!j || j.error) { S.err = (j && j.error) || "review not found"; paint(); return; }
      if (j.status !== "done") { S.note = "That review is still running (" + (j.progress ? j.progress.done + "/" + j.progress.total : "…") + ")."; paint(); return; }
      S.open = j.review;
      paint();
    });
  }

  function pct(v) {
    return Math.round(((v + 1) / 2) * 100);
  }

  function num(v, d) {
    return typeof v === "number" ? v.toFixed(d === undefined ? 3 : d) : "—";
  }

  function when(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleString();
  }

  function seatName(r, seat) {
    const names = (r && (r.seats || (r.setup && r.setup.names))) || [];
    return names[seat] || ("Seat " + (seat + 1));
  }

  function svg(tag, attrs) {
    const node = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for (const k in attrs) node.setAttribute(k, attrs[k]);
    return node;
  }

  function lossClass(loss) {
    if (typeof loss !== "number") return "rvunscored";
    if (loss > BLUNDER) return "rvblunder";
    if (loss > MISTAKE) return "rvmistake";
    return "rvfine";
  }

  function curvePanel(review) {
    const wrap = el("div", "rvcurve");
    const pts = (review.curve || []).filter(function (p) { return typeof p.value === "number"; });
    const span = Math.max(1, review.actions || (pts.length ? pts[pts.length - 1].i : 1));
    const head = el("div", "rvhead");
    head.appendChild(el("div", "disp", "Win probability · " + esc(seatName(review, review.seat))));
    head.appendChild(el("div", "mslbl trmuted", "The native player's estimate for your seat before each of your decisions, at " + esc(review.strength) + " strength."));
    wrap.appendChild(head);
    if (!pts.length) {
      wrap.appendChild(el("div", "msempty", "No scored decisions in this game."));
      return wrap;
    }
    const box = el("div", "rvsvg");
    const s = svg("svg", { viewBox: "0 0 " + CURVE_W + " " + CURVE_H, class: "rvchart", role: "img" });
    const x = function (i) { return (i / span) * CURVE_W; };
    const y = function (v) { return CURVE_PAD + (1 - (v + 1) / 2) * (CURVE_H - 2 * CURVE_PAD); };
    for (const frac of [0, 0.25, 0.5, 0.75, 1]) {
      const gy = y(1 - frac * 2);
      s.appendChild(svg("line", { x1: 0, x2: CURVE_W, y1: gy, y2: gy, class: frac === 0.5 ? "rvmid" : "rvgrid" }));
    }
    let d = "";
    for (let k = 0; k < pts.length; k++) d += (k ? " L" : "M") + x(pts[k].i).toFixed(1) + " " + y(pts[k].value).toFixed(1);
    const mid = y(0).toFixed(1);
    const area = d + " L" + x(pts[pts.length - 1].i).toFixed(1) + " " + mid + " L" + x(pts[0].i).toFixed(1) + " " + mid + " Z";
    s.appendChild(svg("path", { d: area, class: "rvarea" }));
    s.appendChild(svg("path", { d: d, class: "rvline" }));
    const byIndex = {};
    for (const dec of review.decisions || []) byIndex[dec.i] = dec;
    for (const p of pts) {
      const dec = byIndex[p.i];
      const cls = dec ? lossClass(dec.loss) : "rvend";
      const dot = svg("circle", { cx: x(p.i).toFixed(1), cy: y(p.value).toFixed(1), r: dec && typeof dec.loss === "number" && dec.loss > MISTAKE ? 7 : 4, class: "rvdot " + cls });
      const title = svg("title", {});
      title.textContent = dec
        ? "Action " + p.i + " · turn " + dec.turn + " · " + dec.kind + " · " + pct(p.value) + "% · loss " + num(dec.loss)
        : "Action " + p.i + " · final · " + pct(p.value) + "%";
      dot.appendChild(title);
      if (dec) dot.addEventListener("click", function () { branchTo(review, dec); });
      s.appendChild(dot);
    }
    box.appendChild(s);
    wrap.appendChild(box);
    const axis = el("div", "rvaxis");
    axis.appendChild(el("span", "trmuted", "action 0 · top = you win"));
    axis.appendChild(el("span", "trmuted", "dashed line = even"));
    axis.appendChild(el("span", "trmuted", "action " + span));
    wrap.appendChild(axis);
    return wrap;
  }

  function branchTo(review, dec) {
    S.err = null;
    S.note = "Loading the position at action " + dec.i + "…";
    paint();
    get("/api/trainer/game/" + encodeURIComponent(review.gameId), function (j) {
      if (!j || j.error || !j.game) { S.err = (j && j.error) || "the saved game is gone"; S.note = null; paint(); return; }
      try {
        localStorage.setItem(BRANCH_KEY, JSON.stringify({
          game: j.game,
          upto: dec.i,
          seat: review.seat,
          strength: review.strength,
          reviewId: review.id,
        }));
      } catch (e) {
        S.err = "Could not hand the position to the board: " + e.message;
        S.note = null;
        paint();
        return;
      }
      location.href = "/play";
    });
  }

  function decisionRow(review, dec) {
    const row = el("div", "rvrow " + lossClass(dec.loss));
    const head = el("div", "rvrowhead");
    head.appendChild(el("span", "rvloss", typeof dec.loss === "number" ? (dec.loss > 0 ? "−" : "") + Math.abs(dec.loss * 50).toFixed(1) + "%" : "n/a"));
    head.appendChild(el("span", "rvwhere trmuted", "action " + dec.i + " · turn " + dec.turn + " · " + esc(dec.phase || "") + " · " + esc(dec.kind) + " · " + dec.options + " options"));
    const jump = el("button", "btn small", "Replay from here");
    jump.title = "Open the local board at this decision, with the native player in the other seat.";
    jump.onclick = function () { branchTo(review, dec); };
    head.appendChild(jump);
    row.appendChild(head);
    const cmp = el("div", "rvcmp");
    const you = el("div", "rvopt rvchosen");
    you.appendChild(el("div", "mslbl", "You played · " + (typeof dec.chosen.value === "number" ? pct(dec.chosen.value) + "%" : "not searched")));
    you.appendChild(el("div", null, esc(dec.chosen.label)));
    cmp.appendChild(you);
    const best = el("div", "rvopt rvbest");
    best.appendChild(el("div", "mslbl", "Engine line · " + (dec.best && typeof dec.best.value === "number" ? pct(dec.best.value) + "%" : "—")));
    best.appendChild(el("div", null, esc(dec.best ? dec.best.label : "—")));
    cmp.appendChild(best);
    row.appendChild(cmp);
    if ((dec.candidates || []).length > 1) {
      const more = el("details", "rvmore");
      const sum = document.createElement("summary");
      sum.textContent = "All " + dec.candidates.length + " searched lines";
      more.appendChild(sum);
      const list = el("div", "rvcands");
      for (const c of dec.candidates) {
        const line = el("div", "rvcand");
        line.appendChild(el("span", "rvcandv", pct(c.value) + "%"));
        line.appendChild(el("span", null, esc(c.label)));
        if (c.visits !== null && c.visits !== undefined) line.appendChild(el("span", "trmuted rvcandn", c.visits + " visits"));
        list.appendChild(line);
      }
      more.appendChild(list);
      row.appendChild(more);
    }
    return row;
  }

  function reviewPanel(review) {
    const panel = el("div", "trpanel");
    const bar = el("div", "rvbar");
    const back = el("button", "btn ghost small", "← All reviews");
    back.onclick = function () { S.open = null; S.openId = null; S.note = null; paint(); };
    bar.appendChild(back);
    const won = review.winner === review.seat;
    bar.appendChild(el("div", "disp", esc(seatName(review, review.seat)) + " vs " + esc(seatName(review, review.seat === 0 ? 1 : 0))));
    bar.appendChild(el("span", won ? "rvpill rvwin" : "rvpill rvloss2", won ? "WON" : review.winner === null ? "UNFINISHED" : "LOST"));
    bar.appendChild(el("span", "trmuted", (review.points || []).join(" – ") + " · " + review.actions + " actions · " + when(review.createdAt)));
    panel.appendChild(bar);

    const sum = review.summary || {};
    const stats = el("div", "rvstats");
    const tile = function (label, value, cls) {
      const t = el("div", "rvstat" + (cls ? " " + cls : ""));
      t.appendChild(el("div", "rvstatv disp", value));
      t.appendChild(el("div", "mslbl", label));
      return t;
    };
    stats.appendChild(tile("decisions scored", (sum.scored || 0) + " / " + (sum.decisions || 0)));
    stats.appendChild(tile("blunders (>15%)", String(sum.blunders || 0), sum.blunders ? "rvblunder" : null));
    stats.appendChild(tile("mistakes (>5%)", String(sum.mistakes || 0), sum.mistakes ? "rvmistake" : null));
    stats.appendChild(tile("total win prob lost", ((sum.totalLoss || 0) * 50).toFixed(1) + "%"));
    panel.appendChild(stats);

    panel.appendChild(curvePanel(review));

    const scored = (review.decisions || []).slice().sort(function (a, b) {
      const la = typeof a.loss === "number" ? a.loss : -1;
      const lb = typeof b.loss === "number" ? b.loss : -1;
      return lb - la || a.i - b.i;
    });
    const list = el("div", "rvlist");
    list.appendChild(el("div", "mslbl", "Every decision, worst first."));
    for (const dec of scored) list.appendChild(decisionRow(review, dec));
    panel.appendChild(list);
    return panel;
  }

  function queueFor(gameId, seat, strength) {
    post("/api/trainer/review", { gameId: gameId, seat: seat, strength: strength }, function (j) {
      S.queued[j.reviewId] = true;
      S.note = "Review queued. It will appear in the list when the search finishes.";
      refresh();
    });
  }

  function gamesPanel() {
    const box = el("div", "rvgames");
    box.appendChild(el("div", "mslbl", "Saved games — pick a seat to analyse."));
    if (S.games === null) { box.appendChild(el("div", "mslbl", "Loading…")); return box; }
    if (!S.games.length) {
      box.appendChild(el("div", "msempty", "No saved games yet. Finish a local or online duel and press Save for review."));
      return box;
    }
    for (const g of S.games.slice(0, 12)) {
      const row = el("div", "tritem rvgame");
      row.appendChild(el("div", "disp", esc((g.seats || []).join(" vs ") || g.id)));
      row.appendChild(el("div", "mslbl trmuted", when(g.savedAt) + " · " + g.source + " · " + g.actions + " actions"));
      const acts = el("div", "rvgameacts");
      for (const seat of [0, 1]) {
        const b = el("button", "btn small", "Review " + esc((g.seats || [])[seat] || "seat " + (seat + 1)));
        b.onclick = function () { queueFor(g.id, seat, "quick"); };
        acts.appendChild(b);
      }
      row.appendChild(acts);
      box.appendChild(row);
    }
    return box;
  }

  function sparkline(history) {
    const pts = history.slice(-40);
    if (pts.length < 2) return null;
    const vals = pts.map(function (h) { return h.ratingAfter; });
    let lo = Math.min.apply(null, vals);
    let hi = Math.max.apply(null, vals);
    if (hi - lo < 40) { const mid = (hi + lo) / 2; lo = mid - 20; hi = mid + 20; }
    const w = 160;
    const h = 34;
    const s = svg("svg", { viewBox: "0 0 " + w + " " + h, class: "rvspark" });
    let d = "";
    for (let i = 0; i < vals.length; i++) {
      const px = (i / (vals.length - 1)) * w;
      const py = h - ((vals[i] - lo) / (hi - lo)) * (h - 4) - 2;
      d += (i ? " L" : "M") + px.toFixed(1) + " " + py.toFixed(1);
    }
    s.appendChild(svg("path", { d: d, class: "rvsparkline" }));
    return s;
  }

  function ratingPanel() {
    const box = el("div", "rvrating");
    if (!S.rating) {
      box.appendChild(el("div", "mslbl trmuted", "No rating yet — finish a sparring game against the native player."));
      return box;
    }
    const g = S.rating.glicko;
    const left = el("div", "rvratleft");
    left.appendChild(el("div", "rvratv disp", String(Math.round(g.rating))));
    left.appendChild(el("div", "mslbl", "your rating · ±" + Math.round(g.rd) + " · " + (S.rating.history || []).length + " games"));
    box.appendChild(left);
    const spark = sparkline(S.rating.history || []);
    if (spark) box.appendChild(spark);
    const anchors = el("div", "rvanchors mslbl trmuted");
    const a = S.rating.anchors || {};
    anchors.textContent = "anchors · quick " + a.quick + " · normal " + a.normal + " · strong " + a.strong;
    box.appendChild(anchors);
    const last = (S.rating.history || []).slice(-5).reverse();
    if (last.length) {
      const hist = el("div", "rvhist");
      for (const h of last) {
        const chip = el("span", "rvhchip " + (h.result === "win" ? "rvwin" : h.result === "loss" ? "rvloss2" : ""),
          esc(h.result) + " vs " + esc(h.opponent) + " → " + Math.round(h.ratingAfter));
        hist.appendChild(chip);
      }
      box.appendChild(hist);
    }
    return box;
  }

  function listPanel() {
    const panel = el("div", "trpanel");
    panel.appendChild(ratingPanel());
    if (S.list === null) { panel.appendChild(el("div", "mslbl", "Loading…")); return panel; }
    const list = el("div", "trlist");
    if (!S.list.length) {
      list.appendChild(el("div", "msempty", "No reviews yet. Save a finished duel, then analyse a seat below."));
    }
    for (const r of S.list) {
      if (r.error) {
        list.appendChild(el("div", "tritem trmuted", esc(r.id) + " — " + esc(r.error)));
        continue;
      }
      const row = el("div", "tritem rvitem");
      const running = r.status === "queued" || r.status === "running";
      const title = running
        ? "Analysing seat " + (r.seat + 1) + "…"
        : seatName(r, r.seat) + " · seat " + (r.seat + 1) + " of " + (r.seats || []).join(" vs ");
      row.appendChild(el("div", "disp", esc(title)));
      const sum = r.summary || {};
      const sub = running
        ? (r.progress ? r.progress.done + " / " + (r.progress.total === null ? "?" : r.progress.total) + " decisions searched" : "queued")
        : [when(r.createdAt), r.strength, (sum.blunders || 0) + " blunders", (sum.mistakes || 0) + " mistakes",
           "total loss " + ((sum.totalLoss || 0) * 50).toFixed(1) + "%", r.winner === r.seat ? "won" : "lost"].join(" · ");
      row.appendChild(el("div", "mslbl trmuted", esc(sub)));
      if (!running) {
        const open = el("button", "btn small", "Open");
        open.onclick = function () { openReview(r.id); };
        row.appendChild(open);
      }
      list.appendChild(row);
    }
    panel.appendChild(list);
    panel.appendChild(gamesPanel());
    return panel;
  }

  function paint() {
    if (!S.host) return;
    S.host.innerHTML = "";
    if (S.err) S.host.appendChild(el("div", "menuerr", "⚠ " + esc(S.err)));
    if (S.note) S.host.appendChild(el("div", "mslbl trmuted", esc(S.note)));
    if (S.loading) S.host.appendChild(el("div", "mslbl", "Loading review…"));
    S.host.appendChild(S.open ? reviewPanel(S.open) : listPanel());
    schedulePoll();
  }

  window.RB.TrainerReview = {
    render(container) {
      S.host = container;
      S.err = null;
      paint();
      refresh();
    },
    queue: queueFor,
  };
})();
